import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import { Projectmodal } from "../Blog/Modal";
import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { basicauth } from "../Utils/Credentials";

const Navbar = () => {
  const {
    setsiteid,
    setURL,
    siteObj,
    Productname,
    setProductname,
    setIsVerified,
    user,
    setsiteObj,
    setUserDetail,
  } = useContext(GlobalContext);
  
  const [selectedURL, setSelectedURL] = useState({
    label: siteObj?.label || "Select Url",
    value: siteObj?.value || "Select Url",
  });
  const [urlOptions, setUrlOptions] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    if (user) {
      const modalShown = sessionStorage.getItem(`modalShown-${user.id}`);
      if (!modalShown) {
        setModalIsOpen(true);
        sessionStorage.setItem(`modalShown-${user.id}`, "true");
      }
    }
  }, [user]);

  useEffect(() => {
    Getsitemapurl();
  }, [user]);

  useEffect(() => {
    const options = [
      { value: "packky", label: "Packky" },
      { value: "trawlo", label: "Trawlo" },
      { value: "anlook", label: "Anlook" },
      { value: "billpunch", label: "BillPunch" },
      { value: "seobix", label: "SeoBix" },
    ];
    setUrlOptions(options);
  }, []);

  useEffect(() => {
    if (Productname) {
      const selectedOption = urlOptions.find(
        (option) => option.value === Productname
      );
      if (selectedOption) {
        setSelectedURL(selectedOption);
      }
    }
  }, [Productname, urlOptions]);

  const handleSelectChange = (selectedOption) => {
    setsiteid(selectedOption.id);
    setURL(selectedOption.value);
    setProductname(selectedOption.project_name);
    setsiteObj(selectedOption);
    setSelectedURL(selectedOption);

    sessionStorage.setItem("selectedURL", selectedOption.value);
    sessionStorage.setItem("selectedURLId", selectedOption.id);
    sessionStorage.setItem("selectedURLLabel", selectedOption.label);
    sessionStorage.setItem("selectedURLProjectName", selectedOption.project_name);

    setModalIsOpen(false);

    if (selectedOption.is_verified === "N") {
      setIsVerified(false);
    } else {
      setIsVerified(true);
    }
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  
  const Getsitemapurl = async () => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Authorization": `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: user.token_login }),
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/UserInfo/GenerateUserAccessManagement`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        const options = data.result.map((item) => ({
          value: item.site_url,
          label: `${item.site_url} `,
          id: item.identify_id,
          project_name: item.project_name,
          is_verified: item.is_verified,
        }));
        setUrlOptions(options);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "14rem",
    }),
    control: (provided) => ({
      ...provided,
      boxShadow: "none",
      borderRadius: ".4rem",
      width: "13rem",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#f0f0f0" : "#fff",
      color: state.isSelected ? "#000" : "#000",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999",
    }),
  };

  const logoMap = {
    anlook: require("../../assets/images/seoimages/Anlook.svg"),
    billpunch: require("../../assets/images/seoimages/billpunch.png"),
    packky: require("../../assets/images/seoimages/Packky.svg"),
    trawlo: require("../../assets/images/seoimages/trawlo.svg"),
    seobix: require("../../assets/images/seoimages/Seobix.svg"),
  };

  return (
    <>
      <GlobalContext.Consumer>
        {(state) =>
          state.user == null || state.user.user_type == "" ? (
            <Redirect to={`/user-pages/login-2`} />
          ) : (
            <nav
              style={{ background: "#fff" }}
              className="navbar p-0 fixed-top d-flex flex-row"
            >
              <ToastContainer
                autoClose={3000}
                hideProgressBar
                draggableDirection="y"
              />
              <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
                <span
                  style={{ fontSize: "2rem", color: "#FFF", fontWeight: "600" }}
                >
                  SB
                </span>
              </div>

              <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
                <button
                  className="navbar-toggler align-self-center"
                  type="button"
                  onClick={() =>
                    document.body.classList.toggle("sidebar-icon-only")
                  }
                >
                  <span
                    className="mdi mdi-menu"
                    style={{ color: "blue", fontSize: "1.2rem" }}
                  >
                    {" "}
                    &nbsp;&nbsp;&nbsp;
                    <img
                      src={
                        Productname &&
                        logoMap[Productname.toLowerCase()]
                      }
                      alt={Productname}
                      style={{ width: "9vw" }}
                    />
                  </span>
                </button>

                <ul className="navbar-nav navbar-nav-right">
                  <div className="d-flex align-items-center justify-content-end p-0">
                    <span style={{ color: "#0F67B1" }}>
                      Select Project : &nbsp;
                    </span>
                    <Select
                      options={urlOptions}
                      className="basic-single"
                      classNamePrefix="select"
                      placeholder="Select URL"
                      value={selectedURL}
                      onChange={handleSelectChange}
                      styles={customStyles}
                    />
                  </div>
                </ul>
              </div>
            </nav>
          )
        }
      </GlobalContext.Consumer>
      <Projectmodal
        modalIsOpen={modalIsOpen}
        handleClose={() => setModalIsOpen(false)}
        urlOptions={urlOptions}
        selectedURL={selectedURL}
        handleSelectChange={handleSelectChange}
      />
    </>
  );
};

export default Navbar;
